import { Link } from 'react-router-dom'
import './AboutUs.css'
import bannerSnowCappedMountainLakeLandscape from '../assets/bannerSnowCappedMountainLakeLandscape.webp'
import landscapeGirlsTalkingAboutCards from '../assets/landscapeGirlsTalkingAboutCards.webp'
import landscapeThreeGirlsRedCouchQuietTime from '../assets/landscapeThreeGirlsRedCouchQuietTime.webp'
import groupEatingSnack from '../assets/landscapeGroupEatingSnack.webp'
import bannerLakeWater from '../assets/bannerLakeWater.webp'

function AboutUs() {
  return (
    <div className="home-page">
      <div className="row row-1">
        <div className="col col-1-2 banner">
          <h1 className="headerQuote">Nau mai, haere mai ki Taha Wairua</h1>
          <img
            src={bannerSnowCappedMountainLakeLandscape}
            alt="Snow capped mountain lake landscape banner"
            className="banner-image"
            id="topBanner"
          />
        </div>
      </div>

      <div className="row row-2 topRow">
        <div className="col col-1 text-col">
          <div className="text-container">
            <h2 className="content-heading">What We Do</h2>
            <p className="content-paragraph">
              We partner local churches with their neighbourhood schools to host
              a weekly after-school drop-in that’s safe, welcoming, and centred
              on belonging. After hangout time, rangatahi are invited (opt-in)
              to Wairua Time — short, accessible spiritual practices drawn from
              the Christian tradition and shaped by Te Whare Tapa Whā.
            </p>
          </div>
        </div>
        <div className="col col-2 image-col">
          <img
            src={landscapeGirlsTalkingAboutCards}
            alt="Pool table girl portrait"
            className="content-image"
          />
        </div>
      </div>

      <div className="row row-3">
        <div className="col col-1 image-col">
          <img
            src={groupEatingSnack}
            alt="Diary writing blurry background portrait"
            className="content-image"
          />
        </div>
        <div className="col col-2 text-col">
          <div className="text-container">
            <h2 className="content-heading">Why We Do It</h2>
            <p className="content-paragraph">
              Young people across Aotearoa report high levels of loneliness,
              anxiety, and overwhelm, and at the same time, Gen Z are remarkably
              open to spirituality and community. Taha Wairua meets both
              realities: belonging first, then an invitation to explore
              spiritual health.
            </p>
          </div>
        </div>
      </div>

      <div className="row row-4">
        <div className="col col-1 text-col">
          <div className="text-container">
            <h2 className="content-heading">Who It's For?</h2>
            <p className="content-paragraph">
              For intermediate and high-schoolers who want a safe place to land
              after school. Come for kai and mates, opt in to gentle Wairua Time
              if and when you’re ready.
            </p>
          </div>
        </div>
        <div className="col col-2 image-col">
          <img
            src={landscapeThreeGirlsRedCouchQuietTime}
            alt="Table tennis portrait"
            className="content-image"
          />
        </div>
      </div>

      <div className="row row-5">
        <div className="col col-1-2 text-col">
          <div className="about-cta">
            <h1 className="about-cta-heading">
              Contact Us Below For More Information.
            </h1>
            <Link to="/contact" className="about-cta-button">
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div className="row row-6">
        <div className="col col-1-2 banner">
          <img
            src={bannerLakeWater}
            alt="Lake water banner"
            className="banner-image"
          />
        </div>
      </div>
    </div>
  )
}

export default AboutUs
